import React, { useState } from 'react';
import {
    Button,
    Modal,
    Input,
    Space,
    Typography,
    message,
    Form,
    Select,
    Divider,
    notification,
    Spin
} from 'antd';
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import { AddOrUpdateCustomer, DeleteCustomer } from '../redux/LicenseManager/saga';
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

const CustomerManager = ({
    customerList = [],
    onCustomerListChange,
    placeholder = "Select Customer Name",
    style = {},
    value,
    onChange,
  disabled = false,
    loading = false
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [newCustomer, setNewCustomer] = useState('');
    const [editCustomer, setEditCustomer] = useState('');
    const [editIndex, setEditIndex] = useState(-1);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
        setNewCustomer('');
    };

    const handleAddCustomer = async () => {
        if (newCustomer.trim()) {

            const isCustomerExists = customerList.find(item => item.Customer_Name === newCustomer.trim())
            if (isCustomerExists) {
                notification.warning({
                    message: 'Customer already exists!',
                });
                return;
            }
            setIsAddLoading(true);
            try {
                const payload =[{
                    Customer_Name: newCustomer.trim(),
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                }]

                // const customerList = ['Bahia Project',
                //     'Banister',
                //     'Barrilleaux ',
                //     'CAT',
                //     'COOEC',
                //     'CRC Evans',
                //     'Denys Arabia',
                //     'Dev',
                //     'Divatek',
                //     'Interfuse',
                //     'KSA',
                //     'Larrett',
                //     'MCCL',
                //     'Monter',
                //     'N.C',
                //     'Orient GuangZhou',
                //     'Petrojet',
                //     'RMT',
                //     'Ruya',
                //     'Streicher',
                //     'Techint',
                //     'TEST',
                //     'Troy',
                //     'Vemak',
                //     'WEP',
                //     'Westfield India',
                //     'Westfield Nigeria',]
                // const payloadList = customerList.map(item => ({
                //     Customer_Name: item,
                //     createdAt: new Date().toISOString(),
                //     updatedAt: new Date().toISOString()
                // }))



                const response = await AddOrUpdateCustomer(payload, 'Customer')
                  console.log('response', response)   
                if (response && response.length > 0) {
                    const updatedList = [...customerList, {id: response[0].id, Customer_Name: newCustomer.trim(), createdAt: response[0].createdAt, updatedAt: response[0].updatedAt  }];
                    onCustomerListChange(updatedList);
                    setNewCustomer('');
                    setIsModalVisible(false);
                    notification.success({
                        message: 'Customer added successfully!',
                    });
                }
                else {
                    // Fallback: add to local state if API fails

                    notification.success({
                        message: 'Customer adding failed!',
                    });
                }
            } catch (error) {
                notification.success({
                    message: 'Customer adding failed!',
                });
            }
        } else {
            notification.error({
                message: 'Please enter a valid customer name',
            });
        }
        setIsAddLoading(false);
    };

    const handleEditCustomer = async () => {
        if (editCustomer.trim() && editIndex >= 0) {
            setIsEditLoading(true);
            try {
                const payload = {
                    Customer_Name: editCustomer.trim(),
                    id: customerList[editIndex].id,
                    createdAt: customerList[editIndex].createdAt || new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                }
                //  console.log('payload', payload)
                const response = await AddOrUpdateCustomer(payload, 'Customer')
                // console.log('response', response)   
                if (response) {
                    const updatedList = [...customerList];
                    updatedList[editIndex] = {
                        Customer_Name: editCustomer.trim(),
                        id: customerList[editIndex].id,
                        createdAt: customerList[editIndex].createdAt || new Date().toISOString(),
                        updatedAt: new Date().toISOString()
                    };
                    onCustomerListChange(updatedList);
                    setEditCustomer('');
                    setEditIndex(-1);
                    setIsEditModalVisible(false);
                    notification.success({
                        message: 'Customer updated successfully!',
                    });
                }
                // else{
                //     // Fallback: update local state if API fails
                //     const updatedList = [...customerList];
                //     updatedList[editIndex] = { 
                //         Customer_Name: editCustomer.trim(),
                //         id: customerList[editIndex].id,
                //         createdAt:customerList[editIndex].createdAt || new Date().toISOString(),
                //         updatedAt: new Date().toISOString()
                //     };
                //     onCustomerListChange(updatedList);
                //     setEditCustomer('');
                //     setEditIndex(-1);
                //     setIsEditModalVisible(false);
                //     notification.success({
                //         message: 'Customer updated successfully!',
                //     });
                // }
            } catch (error) {
                // Fallback: update local state if API fails

                notification.success({
                    message: 'Customer updated failed!',
                });
            }

        } else {
            notification.error('Please enter a valid customer name');
        }
        setIsEditLoading(false);
    };

    const handleDeleteCustomer = async (index) => {
        try {
            const payload = {
                id: customerList[index].id
            }
            const response = await DeleteCustomer(payload, 'Customer')
            //      console.log('response', response)     
            if (response) {
                const updatedList = customerList.filter((_, i) => i !== index);
                onCustomerListChange(updatedList);
                notification.success({
                    message: 'Customer deleted successfully!',
                });
            }
            else {
                // Fallback: delete from local state if API fails
                const updatedList = customerList.filter((_, i) => i !== index);
                onCustomerListChange(updatedList);
                notification.success({
                    message: 'Customer deleted successfully!',
                });
            }
        } catch (error) {
            // Fallback: delete from local state if API fails
            const updatedList = customerList.filter((_, i) => i !== index);
            onCustomerListChange(updatedList);
            notification.success({
                message: 'Customer deleted successfully!',
            });
        }
    };

    const showEditModal = (customer, index) => {
        setEditCustomer(customer);
        setEditIndex(index);
        setIsEditModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setNewCustomer('');
    };

    const handleEditCancel = () => {
        setIsEditModalVisible(false);
        setEditCustomer('');
        setEditIndex(-1);
    };

    return (
        <div>
            <Select
                placeholder={placeholder}
                className='client-select'
                style={style}
                value={value}
                onChange={onChange}
                disabled={disabled}
                showSearch
                allowClear
                dropdownRender={menu => (
                    <>
                        {menu}
                        <Divider style={{ margin: '5px 0', borderTop: '1px solid lightgrey' }} />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '8px',
                            width: '100%'
                        }}>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModal}
                                style={{ width: '100%', textAlign: 'center', borderRadius: '15px' }}
                            >
                                Add New Customer
                            </Button>
                        </div>
                    </>
                )}
            >
                   {loading && <Spin indicator={<LoadingOutlined spin />} />}
                {customerList.map((item, index) => (
                    <Option key={index} value={item.Customer_Name}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%'
                        }}>
                            <span>{item.Customer_Name}</span>
                            <Space>
                                <Button
                                    type="text"
                                    size="small"
                                    icon={<EditOutlined />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        showEditModal(item.Customer_Name, index);
                                    }}
                                //  style={{ color: '#FFFFFF' }}
                                />
                                {/* <Button
                                    type="text"
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteCustomer(index);
                                    }}
                                    style={{ color: '#ff4d4f' }}
                                /> */}
                            </Space>
                        </div>
                    </Option>
                ))}
            </Select>

            {/* Add Customer Modal */}
            <Modal
                className='client-modal'
                title="Add New Customer"
                visible={isModalVisible}
                footer={[
                    <div style={{ paddingTop: '20px', paddingRight: '10px' }} className='pipeline-btn'>
                        <Button key="cancel"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button key="submit" type="primary"
                            onClick={handleAddCustomer}
                            loading={isAddLoading}
                            style={{
                                backgroundColor: !newCustomer.trim() ? "gray" : "#ef314c",
                            }}
                        >
                            Add
                        </Button>
                    </div>
                ]}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Customer Name"
                        required
                        rules={[{ required: true, message: 'Please enter customer name!' }]}
                    >
                        <Input
                            placeholder="Enter customer name"
                            value={newCustomer}
                            onChange={(e) => setNewCustomer(e.target.value)}
                            onPressEnter={handleAddCustomer}
                            autoFocus
                            size='large'
                            className='client-input'
                        />
                    </Form.Item>
                </Form>
            </Modal>

            {/* Edit Customer Modal */}
            <Modal
                title="Edit Customer"
                className='client-modal'
                visible={isEditModalVisible}
                onOk={handleEditCustomer}
                onCancel={handleEditCancel}
                footer={[
                    <div style={{ paddingTop: '20px', paddingRight: '10px' }} className='pipeline-btn'>
                        <Button key="cancel"
                            onClick={handleEditCancel}
                        >
                            Cancel
                        </Button>
                        <Button key="submit" type="primary"
                            onClick={handleEditCustomer}
                            loading={isEditLoading}
                            style={{
                                backgroundColor: !editCustomer.trim() ? "gray" : "#ef314c",
                            }}
                        >
                            Update
                        </Button>
                    </div>
                ]}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Customer Name"
                        required
                        rules={[{ required: true, message: 'Please enter customer name!' }]}
                    >
                        <Input
                            placeholder="Enter customer name"
                            value={editCustomer}
                            onChange={(e) => setEditCustomer(e.target.value)}
                            onPressEnter={handleEditCustomer}
                            autoFocus
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CustomerManager; 